import { useModal } from "@/contexts/ModalContext";

interface MediaCarouselProps {
  media: string[];
  className?: string;
}

export const MediaCarousel = ({ media, className = "" }: MediaCarouselProps) => {
  const { openModal } = useModal();

  if (!media || media.length === 0) return null;

  return (
    <div className={`flex mx-1 gap-2 flex-wrap ${className}`}>
      {media.map((item, index) => (
        <img
          key={index}
          src={item}
          alt={`Media ${index + 1}`}
          className="w-20 h-20 object-cover rounded-xl flex-shrink-0 cursor-pointer transition-all duration-200 hover:brightness-75 hover:scale-105 hover:shadow-md"
          onClick={() => openModal('media-carousel', { media, initialIndex: index })}
        />
      ))}
    </div>
  );
};
